/* Browser storage, read and written without ever throwing. Storage throws
 * rather than returning null in a private window and under a blocked-cookies
 * policy, and a throw at module scope or on the sign-in path is a page that
 * cannot recover - so every access in the app goes through these.
 *
 * What they deliberately are not: a store. A value read here can be absent
 * whenever storage is, and each caller decides what absent means.
 */

export type StorageArea = "local" | "session";

function area(which: StorageArea): Storage {
  return which === "local" ? window.localStorage : window.sessionStorage;
}

/* The stored value, or null where there is none or storage is unavailable. */
export function readStored(which: StorageArea, key: string): string | null {
  try {
    return area(which).getItem(key);
  } catch {
    return null;
  }
}

/* Store `value`, or remove the key where it is null. Where storage is
 * unavailable nothing is stored, so the value does not survive a reload. */
export function writeStored(which: StorageArea, key: string, value: string | null): void {
  try {
    if (value === null) area(which).removeItem(key);
    else area(which).setItem(key, value);
  } catch {
    // Unavailable storage: see this function's comment.
  }
}
